import saveCurrentEditableCharacteristics from '../helpers/saveCurrentEditableCharacteristics'
import saveCurrentEditableProfile from '../helpers/saveCurrentEditableProfile'
import saveCurrentArmourLocations from '../helpers/saveCurrentArmourLocations'
import saveCurrentCampaignNotes from '../helpers/saveCurrentCampaignNotes'

import saveCurrentSkills from '../helpers/saveCurrentSkills'
import saveCurrentCounts from '../helpers/saveCurrentCounts'
import saveCurrentSpells from '../helpers/saveCurrentSpells'
import saveCurrentItems from '../helpers/saveCurrentItems'

import saveCurrentRunes from '../helpers/saveCurrentRunes'
import saveCurrentAdjs from '../helpers/saveCurrentAdjs'
import copyObjectNoRef from '../helpers/copyObjectNoRef'
//------------------------------
// process save original values
//------------------------------
export default function processSaveOriginalValues({ character }) {
  console.log('------------------------')
  console.log('IN processSaveOriginalValues')
  //
  let original = {
    character: null,
    profile: null,
    chars: null,
    skills: null,
    items: null,
    runes: null,
    counts: null,
    spells: null,
    armour_locations: null,
    adjs: [],
    campaign_notes: null,
  }
  //-----------------------
  // save character object
  //-----------------------
  original.character = copyObjectNoRef(character)
  //--------------------------------------
  // save current editable profile fields
  //--------------------------------------
  original.profile = saveCurrentEditableProfile(character)
  //-------------------------------
  // save editable characteristics
  //-------------------------------
  original.chars = saveCurrentEditableCharacteristics(character)
  //---------------------
  // save current skills
  //---------------------
  original.skills = saveCurrentSkills(character.skills)
  //--------------------
  // save current items
  //--------------------
  original.items = saveCurrentItems(character.items)
  //--------------------
  // save current runes
  //--------------------
  original.runes = saveCurrentRunes(character.runes)
  //---------------------
  // save current counts
  //---------------------
  original.counts = saveCurrentCounts(character.counts)
  //---------------------
  // save current spells
  //---------------------
  original.spells = saveCurrentSpells(character.spells)
  //-------------------------------
  // save current armour locations
  //-------------------------------
  original.armour_locations = saveCurrentArmourLocations(character.armour_locations)
  //-----------------------------
  // save current campaign notes
  //-----------------------------
  original.campaign_notes = saveCurrentCampaignNotes(character.campaign_notes)
  //--------------------------
  // save characteristic adjs
  //--------------------------
  // console.log('SAVING ORIGINAL CHARACTER ADJS = ', character.characteristic_adjs)
  if (character.characteristic_adjs) {
    original.adjs.push(...saveCurrentAdjs('characteristic', character.characteristic_adjs))
  }
  //-------------------------
  // save ability adjs (add)
  //-------------------------
  // console.log('SAVING ORIGINAL ABILITY ADJS = ', character.ability_adjs)
  if (character.ability_adjs) {
    original.adjs.push(...saveCurrentAdjs('ability', character.ability_adjs))
  }
  //----------------------------------------------
  // save characteristic skill adjs (persisted)
  //----------------------------------------------
  if (character.characteristic_skill_adjs) {
    original.adjs.push(
      ...saveCurrentAdjs('characteristic-skill', character.characteristic_skill_adjs),
    )
  }
  //-----------------------
  // save skill adjs (add)
  //-----------------------
  // console.log('SAVING ORIGINAL SKILL ADJS = ', character.skill_adjs)
  if (character.skill_adjs) {
    original.adjs.push(...saveCurrentAdjs('skill', character.skill_adjs))
  }
  // console.log('ORIGINAL CHARACTER ADJS = ', this.original_adjs)
  return original
}
